import React, { useContext, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios'
import { toast } from 'react-toastify';
import authContext from '../../context/authContext/authContext';
import errorHandle from '../../utils/errorHandle';

const ADD_PARTNER_ACCOUNT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/addPartnerAccount";

const AddPartnerAccount = ({ isOpen, toggle, partner, getPartnerAccounts }) => {
  const { getConfig } = useContext(authContext);

  const intialState = { loading: false, name: '', nameError: '', addPartnerAccountError: '' }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const onHideModal = () => {
    setState(intialState)
    toggle();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    addAccount();
  }

  const validateName = () => {
    if (!state.name) {
      setState({ nameError: '*Please enter account holder name' });
    }
  }

  const addAccount = async () => {
    setState({ loading: true })
    const { name, nameError, addPartnerAccountError } = state
    const isValid = name && (nameError === intialState.nameError) && (addPartnerAccountError === intialState.addPartnerAccountError);
    if (!isValid) {
      setState({ addPartnerAccountError: '*Please fill all the required fields' });
      return;
    }

    const data = { partnerId: partner?._id, name }
    const config = getConfig();
    await axios.post(ADD_PARTNER_ACCOUNT_API_END_POINT, data, config)
      .then((res) => {
        setState({ loading: false })
        toast.success(res?.data?.message, { position: 'bottom-right' });
        onHideModal();
        getPartnerAccounts();
      })
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  }

  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Add Partner Account</div>
          <div className='ml-3'>
            {state.loading ? <div class="spinner-border text-primary" role="status" /> : null}
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              class="form-control"
              value={state?.name}
              onChange={(e) => setState({ name: e.target.value })}
              onBlur={validateName}
              onFocus={() => setState({ nameError: '', addPartnerError: '' })}
              disabled={state.loading}
            />
            {state.nameError ? <div className='text-danger ml-2'>{state.nameError}</div> : null}
          </div>

          <div class="form-group">
            <label>Partner</label>
            <input
              type="text"
              class="form-control"
              value={partner?.name}
              disabled
            />
          </div>

          {state?.addPartnerAccountError ? <div className="text-center text-danger">{state?.addPartnerAccountError}</div> : null}
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={state.loading}>
          Cancel
        </Button>
        <Button color="gleamdesk-blue gleamdesk-orange" onClick={handleSubmit} disabled={state.loading}>
          Add Account
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddPartnerAccount